// components/AddCategory.jsx
import { useState } from "react";
import { db } from "../../../firebase";
import { addDoc, collection } from "firebase/firestore";

const AddCategory = () => {
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleAddCategory = async (e) => {
    e.preventDefault();
    
    if (!categoryName.trim()) {
      setMessage("Please enter category name");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      // Create category ID from name (e.g., "CNC Machines" → "cnc-machines")
      const categoryId = categoryName.toLowerCase().replace(/\s+/g, '-');
      
      // Save to Firestore
      await addDoc(collection(db, "categories"), {
        id: categoryId,
        name: categoryName,
        createdAt: new Date()
      });

      setMessage(`✅ Category "${categoryName}" created successfully!`);
      setCategoryName(""); // Clear input
      
    } catch (error) {
      console.error("Error creating category:", error);
      setMessage("❌ Error: " + error.message);
    }
    
    setLoading(false);
  };

  return (
    <>
    <div className="py-10"></div>
    <div style={{ 
      padding: 20, 
      maxWidth: 500, 
      margin: "0 auto",
      fontFamily: "Arial, sans-serif" 
    }}>
      <h2 style={{ color: "#002946", marginBottom: 20 }}>
        Create New Category
      </h2>
      
      <form onSubmit={handleAddCategory}>
        <div style={{ marginBottom: 15 }}>
          <label style={{ 
            display: 'block', 
            marginBottom: 5, 
            fontWeight: 'bold',
            color: '#333'
          }}>
            Category Name *
          </label>
          <input
            type="text"
            placeholder="e.g., CNC Machines, Tapping Machines, Lathe Machines"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            style={{ 
              padding: "12px", 
              width: '100%', 
              border: "1px solid #ccc",
              borderRadius: "6px",
              fontSize: "16px"
            }}
            required
          />
        </div>
        
        <button
          type="submit"
          disabled={loading}
          style={{ 
            padding: "12px 30px", 
            backgroundColor: loading ? '#ccc' : '#002946',
            color: 'white',
            border: 'none',
            borderRadius: "6px",
            fontSize: "16px",
            cursor: loading ? 'not-allowed' : 'pointer',
            width: '100%'
          }}
        >
          {loading ? "Creating Category..." : "➕ Create Category"}
        </button>
      </form>
      
      {message && (
        <p style={{ 
          marginTop: 15, 
          padding: 10, 
          borderRadius: "6px",
          backgroundColor: message.includes('✅') ? '#d4edda' : '#f8d7da',
          color: message.includes('✅') ? '#155724' : '#721c24',
          border: `1px solid ${message.includes('✅') ? '#c3e6cb' : '#f5c6cb'}`
        }}>
          {message}
        </p>
      )}

      {/* Instructions */}
      <div style={{ 
        marginTop: 30, 
        padding: 15, 
        backgroundColor: '#e7f3ff',
        borderRadius: "6px",
        border: '1px solid #b8daff'
      }}>
        <h4 style={{ color: '#002946', marginBottom: 10 }}>📋 Instructions:</h4>
        <ul style={{ color: '#333', lineHeight: 1.6, paddingLeft: 20 }}>
          <li>Enter category name like <strong>"CNC Machines"</strong></li>
          <li>It will automatically create ID: <strong>"cnc-machines"</strong></li>
          <li>After creating categories, you can add machines to them</li>
        </ul>
      </div>
    </div>
    </>
  );
};

export default AddCategory;